// Defoalt is for SECONDARY SCHOOLS API
export const environment = {
  baseUrl: 'https://api.ebill.so:2928/api',
  url: 'https://api.ebill.so:2928/',
  production: true
};